import React from "react";
import { connect } from "react-redux";
import Alert from "../components/Alert";
import { tempAlWait } from "../helpers";
import { delUser, getProfil } from "../actions/user";
import imgBg from "../images/parc/IMG_4132.jpg";

class Profil extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        datas: null
    }
    
    componentDidMount() {
        document.title = "Profil - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        this.props.handleMenu(false);
        if (this.props.canContinue) {
            if (localStorage.getItem('userId') == "null" || localStorage.getItem('userId') == undefined) {
                alert("Vous devez être connecté pour accéder à cette page.");
                window.location.href = `https://${this.props.idtt.slug}.fr`;
            } else {
                this.props.getProfil({userId: localStorage.getItem('userId')});
                this.setState({
                    alert: tempAlWait
                })
            }
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.getProfil({userId: localStorage.getItem('userId')});
                this.setState({
                    alert: tempAlWait
                })
            }
        }

        if (this.props.redProfil != prevProps.redProfil) {
            this.setState({
                alert: this.props.redProfil.alert,
                datas: this.props.redProfil.datas
            })
        }
        
        if (this.props.redDeleteUser != prevProps.deleteUser) {
            if (this.props.redDeleteUser.alert.type == "succ") {
                alert("Votre compte a bien été supprimé. Vous serez rediriger vers la page d'accueil dans quelques instants.");
                window.location.href=`https://${this.props.idtt.slug}.fr`;
            }
        }
    }
    
    handeleLogout = (el) => {
        el.preventDefault();
        
        localStorage.setItem('userId', null);
        localStorage.setItem('userCred', null);
        localStorage.setItem('userRole', null);
        
        alert("Vous êtes bien deconnecté.");
        
        window.location.href=`https://${this.props.idtt.slug}.fr`;
    }
    
    handleDelete = (el) => {
        el.preventDefault();
        
        if (window.confirm("Souhaitez-vous réellement supprimer votre compte ? Cette action est irréversible.")) {
            this.props.delUser({userId: localStorage.getItem('userId')});
        }
    }
    
    render() {
        return <div className="blogp__main pprofil" style={{backgroundImage: `url('${imgBg}')`}}>
            <div className="pprofil__prof">
                {/** Message d'information **/}
                <h2 className="pprofil__ttl">Profil</h2>

                <div className="pprofil__info">
                    <div className="pprofil__mail">
                        <span className="pprofil__lab">Adresse e-mail&nbsp;:</span>
                        <span className="pprofil__txt">{this.state.datas?.email}</span>
                    </div>
                    <div className="pprofil__btns">
                        <button
                            title="Me déconnecter"
                            aria-label="Me déconnecter"
                            className="pprofil__btn"
                            onClick={(el) => this.handeleLogout(el)}
                        >
                            Je me déconnecte
                        </button>
                        <button
                            title="Supprimer mon compte définitivement"
                            aria-label="Supprimer mon compte définitivement"
                            className="pprofil__link"
                            onClick={(el) => this.handleDelete(el)}
                        >
                            Supprimer mon compte définitivement
                        </button>
                    </div>
                </div>
            </div>

            <Alert alert={this.state.alert}/>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redProfil: state.redProfil,
        redDeleteUser: state.redDeleteUser
    }
}

const mapDispatchToProps = {
    getProfil,
    delUser
}

export default connect(mapStateToProps, mapDispatchToProps)(Profil);